import { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';
import {
  ArrowDownTwoMd,
  ArrowUpTwoMd,
  paletteHelper,
  spacingHelper,
  typographyHelper,
} from '@property.com.au/ui-kit';
import { MarketInsightsCostChange, ChangeVariant, ChangeIcon } from '../../types';

const CostChangeContainer = styled.div`
  ${typographyHelper('body02')};
  color: ${paletteHelper('textSecondary')};
`;

const indicatorVariantStylingHelper = (variant: ChangeVariant) => {
  switch (variant) {
    case 'POSITIVE':
      return css`
        color: ${paletteHelper('textGreen')};
      `;
    case 'NEGATIVE':
      return css`
        color: ${paletteHelper('textPink')};
      `;
    case 'NEUTRAL':
      return css`
        color: ${paletteHelper('textPrimary')};
      `;
    default:
      return css`
        color: ${paletteHelper('textSecondary')};
      `;
  }
};

const TrendIndicator = styled.span<{ $variant: ChangeVariant }>`
  ${typographyHelper('body02Bold')};
  margin-left: ${spacingHelper('twoExtraSmall')};
  display: inline-flex;
  align-items: center;
  padding-top: ${spacingHelper('twoExtraSmall')};
  ${(props) => indicatorVariantStylingHelper(props.$variant)};
`;

const TrendIcon = styled.span`
  margin-left: ${spacingHelper('twoExtraSmall')};
  display: inline-flex;
  align-items: center;
`;

const CostChangeIcon: FunctionComponent<{ iconName: ChangeIcon }> = ({ iconName }) => {
  const IconComponent = { ArrowDownTwoMd: ArrowDownTwoMd, ArrowUpTwoMd: ArrowUpTwoMd }[iconName];
  return <IconComponent data-testid={iconName} style={{ width: '17px', height: '17px' }} />;
};

export const CostChange: FunctionComponent<MarketInsightsCostChange> = ({
  title,
  value,
  iconNameV2,
  variant,
}) => {
  return (
    <CostChangeContainer>
      {title}
      <TrendIndicator $variant={variant}>
        {value}
        {iconNameV2 && (
          <TrendIcon>
            <CostChangeIcon iconName={iconNameV2} />
          </TrendIcon>
        )}
      </TrendIndicator>
    </CostChangeContainer>
  );
};
